import React from "react";
import "../SliderFooter/sliderfooter.scss";

const SliderFooter = () => {
    return (
        <div className="slider-footer">
            <img src={require("../SliderFooter/slider-footer-images/landscape-2.jpg")} alt="slider-footer"></img>
        </div>
    )
}

export default SliderFooter;